import { css } from '@emotion/react';
import { Heading, SpinningLoader, Text } from '@frontend/design-system';

const Loader = ({
  title = 'Hold on!',
  subtitle = 'Sip your coffee while we fetch all the latest information for you!',
}: {
  title?: string;
  subtitle?: string;
}) => {
  return (
    <section css={loaderContainerStyle}>
      <SpinningLoader size='xl' />
      <Heading level={1}>{title}</Heading>
      <Text color='light'>{subtitle}</Text>
    </section>
  );
};

export default Loader;

const loaderContainerStyle = css`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--fabric-number-n-4-px);
`;
